Wee.fn.make('cookie', {
	set: function(key, value, options) {
		options = $.extend({
			daysToExpire: 7,
			path: '/',
			domain: '',
			secure: ''
		});

		this.$private.set(key, value, options);
	},

	get: function(key, json) {
		return this.$private.get(key, json);
	},

	delete: function(key) {
		this.$private.delete(key);
	}
}, {
	set: function(key, value, options) {
		var expires = this.getDate(options),
			result = JSON.stringify(value);

		if (/^[\{\[]/.test(result)) {
			value = result;
		}

		$._doc.cookie = [
			key, '=', value,
			'; expires=' + expires,
			options.path ? '; path=' + options.path : '',
			options.secure ? '; secure' + options.secure : ''
		].join('');
	},

	get: function(key, json) {
		var cookies = $._doc.cookie ? $._doc.cookie.split('; ') : [],
			i = 0,
			results = {};

		for (; i < cookies.length; i++) {
			var parts = cookies[i].split('='),
				cookie = parts.slice(1).join('='),
				name = parts[0];

			// Clean up quotes
			if (cookie.charAt(0) === '"') {
				cookie = cookie.slice(1, -1);
			}

			results[name] = parts[1];

			if (key === name) {
				if (json) {
					return JSON.parse(parts[1]);
				}

				return parts[1];
			}
		}

		if (! key) {
			return results;
		}

		return false;
	},

	delete: function(key) {
		this.set(key, '', {
			daysToExpire: -1
		});
	},

	getDate: function(options) {
		var expires = new Date();

		expires.setMilliseconds(
			expires.getMilliseconds() + options.daysToExpire * 864e+5
		);

		return expires.toUTCString();
	}
});